<template>
  <div id="app">
      <router-view></router-view>
  </div>
</template>

<script>
import { getCookie , getDomain , getUrlParams } from '@/utils';
export default {
  name: 'App',
  mounted(e){
     this.cookieFun();
     this.environment();
  },
  methods:{
      //如果有cookie
      cookieFun(){
          let search = getUrlParams(window.location.search);
          let appid = getCookie('appid');
          let domain = getDomain();
          if(search.reset){
            sessionStorage.setItem("isToken",true);
          }
          if(search.c1){      //appid记忆
              if(!appid){
                appid = domain;
              }
              let Callback = encodeURI(`https://${appid}.device.saas.quanmai.cloud${window.location.pathname}?reset=true`);
              window.location.href =  `http://${appid}.saas.quanmai.cloud?Callback=${Callback}&source=3`;
          }else{
              if(appid==domain||domain=='localhost'||domain=='192'||domain=="device"){
                let token = getCookie('token');
                if(token && JSON.parse(sessionStorage.isToken)){
                    sessionStorage.setItem("isToken",false);
                    sessionStorage.setItem("token",token);
                }
              }else{
                sessionStorage.removeItem('token');
              }
          }
      },
      //判断环境
      environment(){
          if(this.isWeixn()){
            sessionStorage.setItem("device", "wx");       //添加微信标识
          } else if (this.isWindows()){
            sessionStorage.setItem("device", "windows");      //添加windows标识
          } else if (this.isAndroid()){
            sessionStorage.setItem("device", "android");  //添加安卓标识
          } else if (this.isNativeAndroid()){
            sessionStorage.setItem("device", "android");  //添加安卓标识
            sessionStorage.setItem("native", "true");     //添加原生标识
          }
      },
      //判断是否是微信
      isWeixn(){
          var ua = navigator.userAgent.toLowerCase();
          if(ua.match(/MicroMessenger/i)=="micromessenger") {
              return true;
          } else {
              return false;
          }
      },
      //判断是否是安卓设备
      isAndroid(){
          if(window["ReactNativeWebView"]){
              return true;
          }else{
              return false;
          }
      },
      //判断是否是安卓 - 原生
      isNativeAndroid(){
          if(window["Android"]){
              return true;
          }else{
              return false;
          }
      },
      //判断是否是win设备
      isWindows(){
          if (window.isElectron) {
              return true;
          }else{
              return false;
          }
      },

  }
}
</script>
